import {isSelectiveAiDomains} from 'common/HelperFunctions'
import {
  getSampleDataCountsFromRedux,
  hasOnboardingSampleData,
} from 'common/helpers/onboardingSampleData'
import {Info} from 'lucide-react'
import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {shallowEqual, useSelector} from 'react-redux'
import {MainReducer, RootState, UserReducer} from 'setup'

import {toAbsoluteUrl} from '_metronic/helpers'

import {DeleteSampleDataModal} from './DeleteSampleDataModal'

const SampleDataAlert: FC = () => {
  const intl = useIntl()
  const [showModal, setShowModal] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  const userPreferences = useSelector<RootState>(
    ({mainReducer}) => mainReducer.userPreferences
  ) as Record<string, unknown> | null

  const mainReducer = useSelector<RootState, MainReducer>(
    ({mainReducer}) => mainReducer,
    shallowEqual
  )

  const userReducer = useSelector<RootState>(
    ({userReducer}) => userReducer,
    shallowEqual
  ) as UserReducer
  const userId = Number(userReducer.user?.id)
  const isPrimaryAdmin = userId === 1

  const showBanner =
    !dismissed &&
    isSelectiveAiDomains() &&
    isPrimaryAdmin &&
    hasOnboardingSampleData(userPreferences)

  if (!showBanner) return null

  return (
    <>
      <div
        id='kt_app_sample_data_alert'
        className='sample-data-banner'
        role='alert'
        aria-live='polite'
      >
        <div className='sample-data-banner__inner'>
          <div className='sample-data-banner__content'>
            <div className='sample-data-banner__icon-wrap' aria-hidden='true'>
              <Info size={22} strokeWidth={2.25} />
            </div>
            <div className='sample-data-banner__text'>
              <p className='sample-data-banner__title'>
                {intl.formatMessage({id: 'SAMPLE_DATA.BANNER.TITLE'})}
              </p>
              <p className='sample-data-banner__message'>
                {intl.formatMessage({id: 'SAMPLE_DATA.BANNER.MESSAGE'})}
              </p>
            </div>
          </div>
          <img
            src={toAbsoluteUrl('golden.jpg')}
            alt=''
            aria-hidden='true'
            className='sample-data-banner__illustration'
          />
          <button
            type='button'
            className='btn sample-data-banner__action'
            onClick={() => setShowModal(true)}
          >
            {intl.formatMessage({id: 'SAMPLE_DATA.BANNER.DELETE'})}
          </button>
        </div>
      </div>

      <DeleteSampleDataModal
        show={showModal}
        counts={getSampleDataCountsFromRedux(mainReducer)}
        onHide={() => setShowModal(false)}
        onDeleted={() => setDismissed(true)}
      />
    </>
  )
}

export {SampleDataAlert}
